import classNames from 'classnames';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { IlButton } from 'il-framework-component';
import PropTypes from 'prop-types';
import React__default from 'react';
import ShowMore from 'react-show-more';
import { Priority, UserInteractionStatus, Label } from './InAppConstants.js';

/**
 * Copyright 2021, IntraLinks, Inc, All rights reserved.
 */
dayjs.extend(relativeTime);
function InAppNotification(_ref) {
  var notificationList = _ref.notificationList,
    handleShowMoreNotification = _ref.handleShowMoreNotification,
    setNotificationClicked = _ref.setNotificationClicked,
    showSeeMoreBtn = _ref.showSeeMoreBtn;
  var notificationListItem;
  if (notificationList.length > 0) {
    notificationListItem = notificationList.map(function (notification) {
      var notificationBar = notification.priority === Priority.HIGH ? 'il-inapp-notification__notification-bar-high' : notification.priority === Priority.MEDIUM ? 'il-inapp-notification__notification-bar-medium' : 'il-inapp-notification__notification-bar-low';
      var notificationBackground = notification.state === UserInteractionStatus.DELIVERED ? 'il-inapp-notification__notification-unread' : 'il-inapp-notification__notification-read';
      return /*#__PURE__*/React__default.createElement("button", {
        type: "button",
        onClick: function onClick() {
          setNotificationClicked(notification);
        },
        className: classNames(notificationBar, notificationBackground, 'il-inapp-notification__notification-list-items-detail'),
        key: notification.id
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "il-inapp-notification__notification-item-timestamp"
      }, dayjs(notification.createdAt).fromNow()), /*#__PURE__*/React__default.createElement("div", {
        className: "il-inapp-notification__notification-item-message"
      }, notification.message), /*#__PURE__*/React__default.createElement(ShowMore, {
        more: Label.READ_MORE,
        less: Label.READ_LESS,
        lines: 2,
        anchorClass: "il-link-button"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "il-inapp-notification__notification--item-details",
        dangerouslySetInnerHTML: {
          __html: notification.details
        }
      })));
    });
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, notificationList.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "il-inapp-notification__notification-list",
    "data-testid": "il-inapp-notification__notification-list-items-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "il-inapp-notification__notification-list-title"
  }, "Notifications"), /*#__PURE__*/React__default.createElement("div", {
    className: "il-inapp-notification__notification-list-container"
  }, notificationListItem, showSeeMoreBtn && /*#__PURE__*/React__default.createElement(IlButton, {
    id: "seeMore",
    className: classNames('il-inapp-notification__notification-see-more-btn', 'il-inapp-notification__notification-list-items-detail'),
    kind: "ghost",
    onClick: function onClick() {
      handleShowMoreNotification();
    }
  }, Label.SEE_MORE))));
}
InAppNotification.propTypes = {
  notificationList: PropTypes.array,
  handleShowMoreNotification: PropTypes.func,
  setNotificationClicked: PropTypes.func,
  showSeeMoreBtn: PropTypes.bool
};
InAppNotification.defaultProps = {
  notificationList: []
};

export { InAppNotification };
